import { GetShippingMethodsParams, ShippingMethodsResults, getShippingMethods } from "@NA/Services/ADIShippingService";
import { getBannerCarousel } from "@NA/Services/GetBannerCarousel";
import { getVisualCarousal, visualCarousalParams, VisualFilterCarousal } from "@NA/Services/GetVisualCarousal";
import { CustomApiHandler } from "@NA/Store/CustomHandlerCreator/CustomHandlerCreator";
import { HasOnSuccess,createHandlerChainRunner, createHandlerChainRunnerOptionalParameter } from "@insite/client-framework/HandlerCreator";

type HandlerType = CustomApiHandler<{
    apiparameter : GetShippingMethodsParams; // P21 Change
    // apiParameter: GetShippingMethodsParams; Code from Spire Prod
} & HasOnSuccess<ShippingMethodsResults>, ShippingMethodsResults>;

export const DispatchvisualFilters: HandlerType = (props: any) => {
    props.dispatch({
        type: "Custom/loadShippingMethods",
        result: props.parameter, // P21 Change
        // result: props.parameter.apiParameter,// code from Spire Prod
    });
};

export const LoadShippingMethods: HandlerType = async (props: any) => {
    props.apiResult = await getShippingMethods(props.parameter.apiparameter); // apiparameter Property is in camelCase in Spire Prod, but not in P21.
};

export const DispatchCompleteloadShippingMethods: HandlerType = props => {
    props.dispatch({
        type: "Custom/DispatchCompleteGetShippingMethod",
        shippingMethods: props.apiResult,
    });
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess?.(props.apiResult);
};

export const chain = [DispatchvisualFilters, LoadShippingMethods, DispatchCompleteloadShippingMethods, ExecuteOnSuccessCallback];

const loadShippingMethods = createHandlerChainRunner(
    chain,
    "loadShippingMethods",
);
export default loadShippingMethods;
